export default "__VITE_ASSET__BLlDtgwb__"